import WidgetItem from "./WidgetItem";

class WidgetItems {
  constructor(private readonly _list: WidgetItem[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public has(index: number): boolean {
    return !!this._list[index];
  }

  public toList(): WidgetItem[] {
    return this._list;
  }

  public findByIndex(index: number): WidgetItem {
    if (this.isEmpty() || !this.has(index)) return new WidgetItem();
    return this._list[index];
  }

  public replace(index: number, widgetItem: WidgetItem): WidgetItems {
    if (this.isEmpty() || !this.has(index)) return new WidgetItems();
    this._list[index] = widgetItem;
    return new WidgetItems(this._list);
  }

  public add(widgetItem: WidgetItem): WidgetItems {
    this._list.push(widgetItem);
    return new WidgetItems(this._list);
  }

  public delete(index: number): WidgetItems {
    if (this.isEmpty() || !this.has(index)) return new WidgetItems(this._list);
    this._list.splice(index, 1);
    return new WidgetItems(this._list);
  }

  public size(): number {
    return this._list.length;
  }
}

export default WidgetItems;
